import React, { useState,useContext, useEffect, useRef } from "react";
import { useLocalStorage } from '_context/commonHooks';

import AsyncSelect from 'react-select/async';
import Select, { components,createFilter } from 'react-select';
import { getItem } from '_services/agent';
import { MapContext } from '_context/MapContext';

const selStyles = {
  option: (styles, state) => ({
    ...styles,
    color: state.isSelected ? "#333" : '#777',
    "&:hover": {
      color: "#333",
      backgroundColor: "#eee"
    }
  }),
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: '#fff',
    '&:hover': {
      borderColor:'#fff',
    }
  }),
  menuList: (provided, state) => ({
    ...provided,
    minHeight:'424px'
  }),
};

const RPSearch = (props) => {
    const [value, setValue] = useState("");
    const [point, setPoint] = useState({});
    //const [history,setHistory] = useLocalStorage('GIS_HistoryList',window.localStorage.getItem('GIS_HistoryList') || []);
    const {history, setHistory} = useContext(MapContext);
    //const selectRef = useRef()

    useEffect(() => {
      if(props.defValue===null){  
        setValue("")
        setPoint({})
       }else{
        if(props.defValue.keyword){
          setValue(props.defValue.keyword)
          setPoint(props.defValue.point)
        }
      }    
    }, [props.defValue]);

    useEffect(() => {
      if(props.signal){
        //if(props.selAfterClear){
          setValue('')
        //}
      }
  }, [props.signal])

    const loadOptions = (inputValue, callback) => {

      getItem('autocomplete','',{
        point: {lat: 37.570026282477116, lng: 126.97714803962387},
        terms: inputValue
     }).then(res => {
              let serverData = res.data.suggests;
              const opts = serverData.map((item) => ({value:item.terms,label:item.terms}));
              callback(opts);
          }).catch(err => {

              }
          );
    };

    
    const onKeyDown = event => {
      if (event.keyCode === 13) {
        event.stopPropagation();
        event.preventDefault();
        props.selectRef.current.setState({menuIsOpen: false})
        props.selectRef.current.blur()
        props.setRoutePoi(props.rid, value);
        if(props.selAfterClear){
          setValue('')
        }
      }
    };

    
    // const onChange = event => {
    //   if(event===null){
    //    props.setRoutePoi(props.rid,"");
    //   }else{
    //     props.setRoutePoi(props.rid, event.label, event.point);
    //   }
    // }
 
    const onChange = (e, { action }) => {
      if(action==="select-option"){
        props.setRoutePoi(props.rid, e.label, e.point);
        if(props.selAfterClear){
          setValue('')
        }
        if(props.through){
          //setValue('')
        }else{
          setValue(e.label)
        }
      }else if(action==="clear"){
        // props.setRoutePoi(props.rid,"");
        // if(props.selAfterClear){
        //   setValue('')
        // }
        setValue("")
      }
    }

    
  const handleSearchInput = (e, { action }) => {
    if (
      action === "menu-close" ||
      action === "input-blur" ||
      action === "set-value"
    ) {
      return;
    } else {
      setValue(e)
    }
  };



    return (
      <AsyncSelect ref={props.selectRef} isDisabled={props.isDisabled}
      loadOptions={loadOptions}
      defaultOptions={history.map((item) => ({value:item.name,label:item.name, point:item.point}))} /* true이면 selbox클릭순간 loadoptions즉시실행하여 초기값 가져오고, 초기 데이터 넣으면 필터링할때만 loadoptions실행 */
      className="mapSearch-container"
      classNamePrefix="mapSearch"
      styles={selStyles}
      placeholder={props.placeholder}
      components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
      noOptionsMessage={() => null}
      isClearable = {true}
      onFocus={props.handleFocus}
      //value={props.defValue?{"value":props.defValue.keyword,"label":props.defValue.keyword,"point":props.defValue.point}:null}
      value={value?{"value":value,"label":value,"point":point}:null}
      inputValue={value}
      onKeyDown={onKeyDown}
      onChange={(e,action)=>onChange(e,action)}
      onInputChange={(e,action)=>handleSearchInput(e,action)}
      // filterOption={createFilter({
      //   matchFrom: 'any',
      //   stringify: option => `${option.label}`,
      // })} 
    />
    );
  };

  export default RPSearch;